import { socialLinks } from "config/config";

const SocialLinks = () => {
  return (
    <div id="social-links">
      {socialLinks.length > 0 && (
        <div className="space-evenly">
          {socialLinks.map(({ link, icon: Icon }, index) => (
            <a
              href={link}
              target="_blank"
              rel="noreferrer"
              key={index}
              className="gridItem"
            >
              <Icon width={24} height={24} />
            </a>
          ))}
        </div>
      )}
    </div>
  );
};

export default SocialLinks;
